import React from 'react';
import PropTypes from 'prop-types';
import {
  CardMedia, Card
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import ListsHeader from '../ListsHeader';
import CreateNewList from '../CreateNewList';
import NullViewContent from './NullViewContent';
import NullViewTexts from '../../../constants/NullViewTexts';

const CompactNullView = ({
  clickID
}) => {
  const { imageAlt, imageUrl } = NullViewTexts;

  return (
    <Card
      data-component="Lists"
      data-testid="compact-null-view"
      className="sui-h-full"
      CardContentProps={{
        className: classNames(
          'sui-flex-col',
          'sui-flex',
          'sui-gap-4',
          'sui-h-full',
          'sui-p-4',
          'sui-w-full'
        )
      }}
    >
      <ListsHeader actions={['learnMore']} clickID={clickID} />
      <div
        className={
          classNames(
            '@3xl:sui-pr-8',
            '@7xl:sui-max-w-md',
            'sui-flex-col',
            'sui-flex',
            'sui-gap-4',
            'sui-h-full',
            'sui-overflow-hidden'
          )
        }
      >
        <CardMedia
          src={imageUrl}
          alt={imageAlt}
          aspect="wide"
        />
        <div
          className={
            classNames(
              '@3xl:sui-pr-8',
              '@7xl:sui-max-w-md',
              'sui-flex-col',
              'sui-flex',
              'sui-gap-4',
              'sui-h-full'
            )
          }
        >
          <NullViewContent />
          <CreateNewList variant="button" />
        </div>
      </div>
    </Card>
  );
};

CompactNullView.propTypes = {
  clickID: PropTypes.string.isRequired
};

export default CompactNullView;
